const accessAmenities = {

    RESOURCE_LIST: { name: 'Resource', path: '/resource-list' },
    ADD_RESOURCE: { name: 'Add Resource', path: '/create-resource' },
    UPDATE_RESOURCE: { name: 'Update Resource', path: '/edit-resource' },
    DELETE_RESOURCE: { name: 'Delete Resource', path: '/delete-resource' },
    RESOURCE_DETAILS: { name: 'Resource Details', path: '/resource-details' },

    BOOKING_LIST: { name: 'Booking Request', path: '/booking-list' },
    ADD_BOOKING: { name: 'Add Booking', path: '/create-booking' },
    UPDATE_BOOKING_STATUS: { name: 'Update Booking Status', path: '/update-booking-status' },

    ADMIN_AMENITIES: { name: 'Admin Amenities', path: '/admin-amenities' },
}

export default accessAmenities;